import React from 'react';

const paths = {
  image: 'M3 3h18v18H3zM3 17l6-6 4 4 3-3 5 5M16 7h.01',
  search: 'm21 21-4.5-4.5M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  bag: 'M5 7h14l1 14H4L5 7Zm3 0V5a4 4 0 0 1 8 0v2',
  box: 'm3 7 9-5 9 5v10l-9 5-9-5V7Zm0 0 9 5 9-5M12 12v10M7.5 4.5l9 5',
  heart:
    'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
  user: 'M20 21v-2a7 7 0 0 0-14 0v2M17 7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
  arrow: 'M4 12h16m-6-6 6 6-6 6',
  chevron: 'm9 5 7 7-7 7',
  close: 'm6 6 12 12M6 18 18 6',
  menu: 'M4 6h16M4 12h16M4 18h16',
  filter: 'M4 7h16M4 17h16M8 4v6M16 14v6',
  wallet:
    'M3 6a3 3 0 0 1 3-3h13v4H6a3 3 0 0 1 0-6M3 6v12a3 3 0 0 0 3 3h15V7H6M21 12h-6v5h6',
  chart: 'M4 3v18h17M9 16v-5M14 16V7M19 16v-8',
  message: 'M21 15a3 3 0 0 1-3 3H8l-5 4V5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10Z',
  tag: 'M20 13 11 22 2 13V3h10l8 8a1.5 1.5 0 0 1 0 2ZM7 7h.01',
  layers: 'm12 3 10 5-10 5L2 8l10-5ZM2 12l10 5 10-5M2 16l10 5 10-5',
  logout: 'M9 3H3v18h6M10 12h11m-4-4 4 4-4 4',
  plus: 'M12 5v14M5 12h14',
  check: 'm5 12 4 4L19 6',
  alert: 'm12 3 10 18H2L12 3Zm0 6v5m0 3h.01',
  refresh:
    'M20 7v5h-5M4 17v-5h5M5.5 6.5A8 8 0 0 1 20 12M4 12a8 8 0 0 0 14.5 5.5',
  shirt: 'm8 3 4 2 4-2 6 4-3 5-3-2v11H8V10l-3 2-3-5 6-4Z',
  shoe: 'M3 14c3 0 4-3 4-6l4 3 4 1 6 4v4H3v-6Zm8-3-1 3m4-2-1 3M3 17h18',
  home: 'm3 10 9-8 9 8v11h-7v-7h-4v7H3V10Z',
  edit: 'm16 3 5 5-12 12-6 1 1-6L16 3Zm-2 2 5 5',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7',
};

export default function Icon({ name, size = 20, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d={paths[name] || paths.box} />
    </svg>
  );
}
